import React from "react";

const ProductPriceBlock = ({ priceObject, oldPrice, withLabel, product, bestValue, bundledPrices }) => {
  return (
    <div className="productPacItem__priceBlock__container">
      <div data-cy="product-price-old" className="productPacItem__priceBlock__oldPrice">
        {oldPrice && oldPrice}
      </div>
      <div className="productPacItem__priceBlock__mainPriceBlock">
        {priceObject?.symbolLeft && <sup>{priceObject?.symbol}</sup>}
        <div data-cy="product-price" className="productPacItem__priceBlock__price">
          {priceObject?.number && priceObject?.number}
        </div>

        <div className="productPacItem__priceBlock__centsBlock">
          <div data-cy="product-price-cents" className="productPacItem__priceBlock__cents">
            {priceObject?.hasCents && `. ${priceObject?.cents}`}
          </div>

          <div
            className={`productPacItem__priceBlock__each
                ${
                  priceObject?.hasCents
                    ? `productPacItem__priceBlock__each--with-cents`
                    : `productPacItem__priceBlock__each--without-cents`
                } `}
          >
            {!bundledPrices && window.post_template.checkout_v4_products.tr_checkout_v4_products_eachLabel}
          </div>
        </div>
        {!priceObject?.symbolLeft && (
          <div className="productPacItem__priceBlock" style={{ marginLeft: "2px" }}>
            <sup>{priceObject?.symbol}</sup>
          </div>
        )}
      </div>
      {withLabel && <div className="productPacItem__priceBlock__labelTag">{product.status?.toUpperCase()}</div>}
      {bestValue && (
        <div className="productPacItem__priceBlock__bestValueTag">{product.tr_best_value_status.toUpperCase()}</div>
      )}
    </div>
  );
};

export default ProductPriceBlock;
